<template>
	<v-container fluid class="pa-0">
		<v-toolbar flat dense dark :style="stickyTop" extension-height="4">
			<v-toolbar-title>{{ $t("IC Aangiften") }} </v-toolbar-title>
			<template #extension v-if="loading">
				<v-progress-linear bottom indeterminate color="white"></v-progress-linear>
			</template>
		</v-toolbar>
		<v-container>
			<v-row justify="center">
				<v-col cols="12" md="10">
					<v-card flat outlined>
						<v-data-table disable-sort disable-pagination hide-default-footer :items="icDeclarations"
							:headers="headers" single-expand show-expand :expanded.sync="expanded"
							v-on:item-expanded="getPdf" item-key="aangiftenr" expand-icon="mdi-file-document-outline">
							<template v-slot:[`item.vandatum`]="{ item }">
								{{ $d(new Date(item.vandatum), "short") }}
							</template>
							<template v-slot:[`item.totdatum`]="{ item }">
								{{ $d(new Date(item.totdatum), "short") }}
							</template>
							<template v-slot:expanded-item="{ headers, item }">
								<td :colspan="headers.length">
									<pdf :src="src" class="ma-3" v-if="item.document_usds_id" />
									<p v-else>
										Het document is niet beschikbaar
									</p>
								</td>
							</template>
						</v-data-table>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
import caas from "@/services/caas";
import pdf from "vue-pdf";
import { useSessionStore } from "@/store/session";
export default {
	name: "IcDeclaration",
	components: { pdf },
	computed: {
		stickyTop() {
			return {
				position: "sticky",
				top: this.$vuetify.application.top + "px",
				zIndex: 1,
			};
		},
	},
	data() {
		return {
			expanded: [],
			loading: false,
			icDeclarations: [],
			headers: [
				{ text: "Aangiftenr", value: "aangiftenr" },
				{ text: "Van datum", value: "vandatum" },
				{ text: "Tot datum", value: "totdatum" },
				{ text: "Jaar", value: "kaljaar" },
				{ text: "Maand", value: "kwartaal" },
				{ text: "Bevestiging ontvangst", value: "data-table-expand" },
			],
			src: null,
			showPdf: false,
			sessionStore: useSessionStore()
		};
	},
	methods: {
		async fetchIcDeclarations() {
			const sdoName = "boek/objects/dIclh.r";
			let params = {
				action: "read",
				fiscalYear: Number(this.sessionStore.fiscalYear),
				nbrOfRows: 20,
				setOpenQuery: `for each iclh where kaljaar = ${this.sessionStore.fiscalYear} no-lock indexed-reposition`,
			};

			this.loading = true;
			const response = await caas.sdo(sdoName, params);
			this.icDeclarations = response.data.data.RowObject;
			this.loading = false;
		},
		async getPdf(obj) {
			if (obj.value) {
				if (obj.item.document_usds_id) {
					this.loading = true;
					let params = {
						usds_id: Number(obj.item.document_usds_id),
					};
					caas.rpc("getBLOB", params).then((response) => {
						const binaryString = window.atob(
							response.data.blob
						);
						const len = binaryString.length;
						const bytes = new Uint8Array(len);
						for (let i = 0; i < len; ++i) {
							bytes[i] = binaryString.charCodeAt(i);
						}
						this.src = bytes; //new Blob([bytes], { type: "application/pdf" });
						this.loading = false;
						this.showPdf = true;
					});
				}
			} else {
				this.showPdf = false;
				this.src = null;
			}
		},
	},
	mounted() {
		this.fetchIcDeclarations();
	},
};
</script>
